import * as yup from 'yup';
import { CpfCnpjValidator } from './cpfCnpj';

yup.addMethod(yup.string, 'cpfCnpj', function (message = 'CPF ou CNPJ inválido') {
    return this.test('cpf-cnpj', message, function (value) {
        return CpfCnpjValidator.isValid(value);
    });
});

export default yup;
